import React from 'react'
import { Helmet } from 'react-helmet'
import SubresellerLoginContainer from 'containers/panel/subreseller/login-container'
const CustomerLoginPage = () => {
  return (
    <>
     <Helmet>
      <title>Alt Kurumsal Giriş | SkyPay</title>
    </Helmet>
    <SubresellerLoginContainer/>
    </>
  )
}

export default CustomerLoginPage